// src/data/species.ts

export const SPECIES_GROUPS = [
    ['Perro', 'Gato'], // AMIGOS PELUDOS
    ['Conejo', 'Hurón', 'Erizo de Tierra', 'Cobaya', 'Hámster', 'Chinchilla', 'Rata Doméstica', 'Jerbo', 'Degú', 'Minipig'], // PEQUEÑOS MAMÍFEROS
    ['Ninfa/Catita', 'Loro', 'Canario', 'Gallina'], // AVES
    ['Tortuga de Tierra', 'Tortuga de Agua', 'Iguana', 'Gecko', 'Serpiente'], // REPTILES
    ['Caballo', 'Otro'] // GRANJA / OTROS
];

export const INTERVIEW_CONFIG = {
    'AMIGOS PELUDOS': { food: 'Marca de Alimento', toy: 'Juguete Favorito', mischief: 'Travesura Típica', fears: 'Miedos / Fobias', anger: '¿Qué lo hace enojar?', tricks: 'Trucos / Habilidades', reward: 'Premio Favorito' },
    'PEQUEÑOS MAMÍFEROS': { food: 'Tipo de Dieta / Heno', toy: 'Enriquecimiento', mischief: 'Hábito Destructivo', fears: 'Estresores', anger: '¿Cuándo muerde/bufa?', tricks: 'Habilidades', reward: 'Snack Favorito' },
    'AVES': { food: 'Mezcla / Semillas / Pellet', toy: 'Juguete de Pico', mischief: 'Conducta / Destrozos', fears: 'Sustos', anger: '¿Qué lo pone agresivo?', tricks: 'Palabras / Cantos', reward: 'Golosina' },
    'REPTILES': { food: 'Fuente de Alimento', toy: 'Decoración / Refugio', mischief: 'Hábito de Fuga', fears: 'Estrés Ambiental', anger: 'Señales de Defensiva', tricks: 'Comportamiento', reward: 'Alimento Premium' },
    'GRANJA': { food: 'Forraje / Concentrado', toy: 'Objeto de Entretenimiento', mischief: 'Vicios de Cuadra', fears: 'Asustadizo con...', anger: 'Resabios / Molestias', tricks: 'Disciplina / Doma', reward: 'Premio / Mimo' },
    'DEFAULT': { food: 'Comida Favorita', toy: 'Juguete Favorito', mischief: 'Travesura', fears: 'Miedos', anger: 'Cosas que le molestan', tricks: 'Trucos', reward: 'Premio' }
};

export const SPECIES_CONFIG: Record<string, { breeds: string[], labels: { breed: string, color: string, markings: string } }> = {
    'Perro': {
        breeds: ['Mestizo', 'Pastor Alemán', 'Poodle', 'Bulldog', 'Golden Retriever', 'Chihuahua', 'Yorkshire', 'Boxer', 'Dachshund', 'Pug', 'Shih Tzu', 'Schnauzer', 'Cocker Spaniel', 'Border Collie', 'Akita', 'Husky Siberiano', 'Beagle', 'Bulldog Francés', 'Labrador', 'Otra'],
        labels: { breed: 'Raza', color: 'Color Dominante', markings: 'Manchas / Señas' }
    },
    'Gato': {
        breeds: ['Doméstico (Mestizo)', 'Siamés', 'Persa', 'Maine Coon', 'Bengala', 'Sphynx', 'British Shorthair', 'Ragdoll', 'Angora', 'Otra'],
        labels: { breed: 'Raza', color: 'Color Principal', markings: 'Patrón (Rayas/Manchas)' }
    },
    'Conejo': {
        breeds: ['Enano', 'Belier (Orejas Caídas)', 'Cabeza de León', 'Rex', 'Angora', 'Nueva Zelanda', 'Flemish Giant', 'Común'],
        labels: { breed: 'Raza', color: 'Color Pelaje', markings: 'Señas Particulares' }
    },
    'Hurón': {
        breeds: ['Sable', 'Albino', 'Chocolate', 'Champagne', 'Canela', 'Silver', 'Panda', 'Black Self'],
        labels: { breed: 'Coloración', color: 'Tono Base', markings: 'Patrón / Antifaz' }
    },
    'Erizo de Tierra': {
        breeds: ['Sal y Pimienta', 'Canela', 'Cinnicot', 'Champagne', 'Apricot', 'Albino', 'Pinto'],
        labels: { breed: 'Color de Púas', color: 'Color de Piel', markings: 'Máscara Facial' }
    },
    'Cobaya': {
        breeds: ['Americana (Pelo Corto)', 'Abisinia (Remolinos)', 'Peruana (Pelo Largo)', 'Baldwin (Sin Pelo)', 'Teddy', 'Rex'],
        labels: { breed: 'Raza / Pelo', color: 'Color', markings: 'Distribución' }
    },
    'Hámster': {
        breeds: ['Sirio (Dorado)', 'Ruso Enano', 'Roborovski', 'Chino'],
        labels: { breed: 'Especie', color: 'Color', markings: 'Marcas' }
    },
    'Chinchilla': {
        breeds: ['Gris Standard', 'Beige', 'White Wilson', 'Ebony', 'Black Velvet', 'Violeta'],
        labels: { breed: 'Mutación Color', color: 'Tono', markings: 'Uniformidad' }
    },
    'Rata Doméstica': {
        breeds: ['Standard', 'Dumbo', 'Rex', 'Sin Pelo'],
        labels: { breed: 'Variedad', color: 'Color', markings: 'Patrón (Hooded, Berkshire)' }
    },
    'Jerbo': {
        breeds: ['Mongol', 'Otras'],
        labels: { breed: 'Especie', color: 'Color', markings: 'Marcas' }
    },
    'Degú': {
        breeds: ['Común (Agouti)', 'Azul', 'Sand', 'Blanco'],
        labels: { breed: 'Color', color: 'Tono', markings: 'Marcas Blancas' }
    },
    'Minipig': {
        breeds: ['Vietnamita', 'Juliana', 'Kune Kune', 'Göttingen'],
        labels: { breed: 'Raza', color: 'Color Piel/Pelo', markings: 'Manchas' }
    },
    'Tortuga de Tierra': {
        breeds: ['Mediterránea', 'Rusa', 'Sulcata', 'Leopardo', 'Patas Rojas'],
        labels: { breed: 'Especie', color: 'Color Caparazón', markings: 'Patrón Escudos' }
    },
    'Tortuga de Agua': {
        breeds: ['Orejas Rojas', 'Orejas Amarillas', 'Mapa', 'Lagarto'],
        labels: { breed: 'Especie', color: 'Color Plastrón', markings: 'Dibujos Caparazón' }
    },
    'Iguana': {
        breeds: ['Verde', 'Roja', 'Azul (Axanthic)', 'Albina'],
        labels: { breed: 'Morfo / Color', color: 'Tono Predominante', markings: 'Espinas / Cola' }
    },
    'Gecko': {
        breeds: ['Leopardo', 'Crestado', 'Gargola', 'Diurno'],
        labels: { breed: 'Especie', color: 'Fase (Morph)', markings: 'Puntos / Rayas' }
    },
    'Serpiente': {
        breeds: ['Pitón Bola', 'Maicera', 'Rey', 'Boa'],
        labels: { breed: 'Especie', color: 'Fase (Morph)', markings: 'Patrón Escamas' }
    },
    'Ninfa/Catita': {
        breeds: ['Ancestral (Gris)', 'Lutina (Amarilla)', 'Perlada', 'Carablanca', 'Albina'],
        labels: { breed: 'Mutación', color: 'Color Cuerpo', markings: 'Anilla (ID)' }
    },
    'Loro': {
        breeds: ['Yaco', 'Amazonas', 'Guacamayo', 'Eclectus', 'Cotorra'],
        labels: { breed: 'Especie', color: 'Plumaje', markings: 'Anilla (ID)' }
    },
    'Canario': {
        breeds: ['Timbrado', 'Roller', 'Malinois', 'Color', 'Postura'],
        labels: { breed: 'Tipo', color: 'Color', markings: 'Anilla' }
    },
    'Gallina': {
        breeds: ['Sedosa', 'Brahma', 'Leghorn', 'Araucana', 'Kikiriki'],
        labels: { breed: 'Raza', color: 'Plumaje', markings: 'Cresta' }
    },
    'Caballo': {
        breeds: ['Chileno', 'Árabe', 'Cuarto de Milla', 'Inglés', 'Pony', 'Mestizo'],
        labels: { breed: 'Raza', color: 'Pelaje (Capa)', markings: 'Señas (Lucero, Calzado)' }
    },
    'Otro': {
        breeds: ['Otra'],
        labels: { breed: 'Tipo', color: 'Color', markings: 'Señas' }
    }
};
